import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-blog-read-directory',
  templateUrl: './blog-read-directory.component.html',
  styleUrls: ['./blog-read-directory.component.scss']
})
export class BlogReadDirectoryComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Verzeichnis einlesen');
    this.seo.updateKeywords('FAQ,Verzeichnis einlesen,Menü erstellen');
  }
}
